import React, { useContext } from "react";
import { MultipleMenu, Logout } from "../components/sidebar";
import { DrawerContext } from "../context/Drawer";
import Section from "../components/elements/Section";
import Cookies from 'js-cookie';
import sidebarGuest from "../data/master/sidebarGuest.json";
import data from "../data/master/sidebar.json";
export default function Sidebar() {

    const { drawer } = useContext(DrawerContext);
    const role = Cookies.get(`${process.env.REACT_APP_USERID_ROLE}`);


    return (
        <Section as="aside" className={`mc-sidebar thin-scrolling ${drawer ? "active" : ""}`}>
            {role === "admin" || role === "superadmin" ? 
            <MultipleMenu data={data?.navs} /> : <MultipleMenu data={sidebarGuest?.navs} />}

            <Logout data={data?.button} />
        </Section>
        // { 
        //     "href": "/order-list",
        //     "icon": "shopping_cart", 
        //     "text": "orders",
        //     "badge": { "text": "05", "variant": "primary round" }
        // },
    )
}